import React from "react"
import { Chantier, Planning } from "../interfaces";

const CalendarContext = React.createContext < {
    refreshCalendar: boolean;
    setRefreshCalendar: React.Dispatch<React.SetStateAction<boolean>>;
    chantier: Chantier[];
    isLoadingModal: boolean;
    setIsLoadingModal: React.Dispatch<React.SetStateAction<boolean>>;
    chantierLoadingFinish: boolean;
    setChantierLoadingFinish: React.Dispatch<React.SetStateAction<boolean>>;
    planning: Planning[];
    setPlanning: React.Dispatch<React.SetStateAction<Planning[]>>;
}>({
    refreshCalendar: false,
    setRefreshCalendar: () => {},
    chantier: [] ,
    isLoadingModal: true,
    setIsLoadingModal: () => {},
    setChantierLoadingFinish: () => {},
    chantierLoadingFinish: false,
    planning: [],
    setPlanning: () => {}
});

export default CalendarContext